import React from 'react';
import {IDeviceActivityTransform} from "@containers/device/containers/deviceActivity/types";
import {IColumnItem} from "@ui/tableCustom/types/columns";
import {getValueTransformData} from "@helpers/transform/transform";
import {
    getColorByDeviceActivityStatus
} from "@containers/device/containers/deviceActivity/helpers/getColorByDeviceActivityStatus";
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import {sx} from "@containers/device/containers/deviceActivity/listDeviceActivity/item/sx";
import ButtonToggleRowExport
    from "@containers/export/containers/buildData/view/buttons/buttonToggleRowExport/ButtonToggleRowExport";
import {IExportFeaturesProps} from "@ui/tableCustom/types/exportProps";


interface IProps {
    content: IDeviceActivityTransform,
    column: IColumnItem<IDeviceActivityTransform>,
    exportFeaturesProps: IExportFeaturesProps
}


const CurrentValue = ({
                          content,
                          column,
                          exportFeaturesProps
                      }: IProps) => {

    switch (column.id) {

        case "displayName": {
            return (
                <Stack
                    direction={'row'}
                    alignItems={'center'}
                    justifyContent={'flex-start'}
                    gap={1}
                    sx={sx.inner}
                >
                    <ButtonToggleRowExport
                        exportFeaturesProps={exportFeaturesProps}
                        id={content.id}
                    />
                    {getValueTransformData(content, 'displayName')}
                </Stack>
            )
        }
        case "status": {
            return (
                <Stack
                    direction={'row'}
                    alignItems={'center'}
                    gap={'3px'}
                >
                    {getValueTransformData(content, 'status')}

                    <Box
                        sx={{
                            width: '20px',
                            height: '20px',
                            backgroundColor: getColorByDeviceActivityStatus(content?.status)
                        }}
                    />
                </Stack>
            )
        }

        default :
            return getValueTransformData(content, column.id)
    }

};

export default CurrentValue;